import { NgModule } from '@angular/core';

import { LoginComponent } from './component/login/login.component';
import { RouterModule } from '@angular/router';
import { SessionRoutes } from './session.routes';
import { LoginForm } from './component/login/login.form';
import { SharedModule } from '../shared/shared.module';
import { SessionManager } from './service/session-manager';
import { SessionTokenService } from './service/session-token';
import { SessionResolver } from './service/session-resolver';
import { Ng5SliderModule } from 'ng5-slider';
import { PasswordChangeComponent } from './component/password-change/password-change.component';
import { PasswordResetComponent } from './component/password-reset/password-reset.component';
import { PasswordChangeForm } from './component/password-change/password-change.form';
import { PasswordResetForm } from './component/password-reset/password-reset.form';
import { DeviceFingerprintService } from './service/device-fingerprint-service';
import { SingleSignOnComponent } from './component/single-sign-on/single-sign-on.component';
import { LoggedOutComponent } from './component/logged-out/logged-out.component';
import { LoginLegacyComponent } from './component/login-legacy/login-legacy.component';
import { LoginLegacyForm } from './component/login-legacy/login-legacy.form';

@NgModule({
  declarations: [
    LoginComponent,
    LoginLegacyComponent,
    PasswordChangeComponent,
    PasswordResetComponent,
    SingleSignOnComponent,
    LoggedOutComponent
  ],
  imports: [
    RouterModule.forChild(SessionRoutes),
    SharedModule,
    Ng5SliderModule
  ],
  exports: [
    SingleSignOnComponent
  ],
  providers: [
    LoginForm,
    LoginLegacyForm,
    SessionTokenService,
    SessionManager,
    SessionResolver,
    PasswordChangeForm,
    PasswordResetForm,
    DeviceFingerprintService
  ]
})
export class SessionModule {

}
